export default __webpack_public_path__ + "static/media/edit_category.620fe836.svg";